import angular from 'angular';

import CategoryGroupComponent from './category-group.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component.category-group', [])
    .component(CategoryGroupComponent.selector, CategoryGroupComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/category-group/index.js